import axios from 'axios'
import utils from './index'
import store from '@core/store'
import session from '@/utils/session'
import storage from '@/utils/storage'
import constant from './constant'
const isDevelopmentEnv = process.env.NODE_ENV === 'development'
const config = require('../../../config')
const httpSetting = config[isDevelopmentEnv ? 'dev' : 'build'].httpSetting
const http = axios.create(httpSetting)

http.interceptors.request.use(req => {
  req.headers = Object.assign(req.headers.common || {}, {
    'loginsession': storage.get('token') || session.get('loginToken')
  })
  req.data = req.data || {}
  req.data.loginsession = storage.get('token')
  req.data.areaId = isDevelopmentEnv ? 1 : (req.data.areaId === null ? null : (req.data.areaId || store.getters.parkId))
  req.data.globalAreaId = req.data.parkId
  req.data.enterpriseId = req.data.enterpriseId === null ? null : (req.data.enterpriseId || store.getters.userInfo.companyId)
  return req
}, error => {
  return Promise.reject(error)
})

const browser = utils.browserVersion()
const service = {
  _simpleOptions: {
    areaId: 0,
    areaName: '',
    enterpriseId: 0,
    enterpriseName: '',
    departmentId: 0,
    departmentName: '',
    moduleType: 1,
    username: '',
    realName: '',
    sex: 0
  },
  _options: {
    platform: 'web',
    manufactor: browser.mac ? 'mac' : 'windows',
    model: browser.browser,
    os_version: browser.version,
    events: []
  },
  _baseEvenet: {
    app_version: constant.VERSION,
    type: 2000,
    name: '',
    params: {},
    timestamps: []
  },
  base (params, callback) {
    http.post('/area-admin/buriedPoint/addBuriedPoint', params).then(res => {
      console.log(res)
      callback && callback()
    })
  },
  clickEvent (params) {
    let clickEvent = this._getSimpleEevent()
    clickEvent.eventType = 0 // 0是点击事件
    clickEvent.page = params.name
    this.base(clickEvent)
  },
  showEvent (params) {
    let showEvent = this._getSimpleEevent()
    showEvent.eventType = 1 // 1是展示事件
    showEvent.page = params.name
    this.base(showEvent)
  },
  _getBaseEvent (params) {
    let baseEvent = {...this._baseEvenet}
    baseEvent.eventId = Date.now()
    baseEvent.name = params.name // 业务名称
    baseEvent.type = 2000
    baseEvent.timestamps.push(Date.now())
    baseEvent.user_name = params.id // 用户id
    baseEvent.params = JSON.stringify(params.data) // 其他参数
    return baseEvent
  },
  _getSimpleEevent () {
    const areaInfo = store.getters.areaInfo || store.getters.parkList[0]
    const userInfo = store.getters.userInfo
    console.log(userInfo)
    console.log(areaInfo)
    let simpleEvent = {
      areaId: areaInfo.areaId,
      areaName: areaInfo.areaName,
      enterpriseId: userInfo.companyId,
      enterpriseName: userInfo.companyName,
      departmentId: userInfo.departmentId,
      departmentName: userInfo.departmentName,
      username: userInfo.id,
      realName: userInfo.realName,
      sex: parseInt(userInfo.sex)
    }
    return simpleEvent
  }
}

export default service



// WEBPACK FOOTER //
// ./src/area-base/utils/aggregated.js